import { apiCall } from './api';
import { INVITE_LIST, INVITE_LIST_DETAILS, INVITE_LIST_STATUS, INVITE_LIST_STATS, INVITE_LIST_SEND_EMAIL, SEND_MAIL } from '../config/api';

// Get all Invite List items
export const getInviteList = async (params = {}) => {
  try {
    console.log('🚀 getInviteList called with params:', params);
    console.log('🔗 Making API call to:', INVITE_LIST);
    
    const response = await apiCall(INVITE_LIST, {
      method: 'GET',
      params
    });
    
    console.log('📡 API Response from getInviteList:', response);
    return response;
  } catch (error) {
    console.error('❌ Error in getInviteList:', error);
    throw error;
  }
};

// Get Invite List item by ID
export const getInviteListById = async (inviteId) => {
  try {
    const endpoint = INVITE_LIST_DETAILS.replace('{id}', inviteId);
    const response = await apiCall(endpoint, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching Invite List item:', error);
    throw error;
  }
};

// Create new Invite List item
export const createInviteList = async (inviteData) => {
  try {
    console.log('🚀 createInviteList called with data:', inviteData);
    console.log('🔗 Making API call to:', INVITE_LIST);
    
    const response = await apiCall(INVITE_LIST, {
      method: 'POST',
      data: inviteData
    });
    
    console.log('📡 API Response from createInviteList:', response);
    return response;
  } catch (error) {
    console.error('❌ Error creating Invite List item:', error);
    throw error;
  }
};

// Update Invite List item
export const updateInviteList = async (inviteId, inviteData) => {
  try {
    const endpoint = INVITE_LIST_DETAILS.replace('{id}', inviteId);
    console.log('🚀 updateInviteList called with ID:', inviteId, 'and data:', inviteData);
    console.log('🔗 Making API call to:', endpoint);
    
    const response = await apiCall(endpoint, {
      method: 'PUT',
      data: inviteData
    });
    
    console.log('📡 API Response from updateInviteList:', response);
    return response;
  } catch (error) {
    console.error('❌ Error updating Invite List item:', error);
    throw error;
  }
};

// Delete Invite List item
export const deleteInviteList = async (inviteId) => {
  try {
    const endpoint = INVITE_LIST_DETAILS.replace('{id}', inviteId);
    const response = await apiCall(endpoint, {
      method: 'DELETE'
    });
    return response;
  } catch (error) {
    console.error('Error deleting Invite List item:', error);
    throw error;
  }
};

// Update Invite List status
export const updateInviteListStatus = async (inviteId, status) => {
  try {
    const endpoint = INVITE_LIST_STATUS.replace('{id}', inviteId);
    const response = await apiCall(endpoint, {
      method: 'PATCH',
      data: { status }
    });
    return response;
  } catch (error) {
    console.error('Error updating Invite List status:', error);
    throw error;
  }
};

// Get Invite List statistics
export const getInviteListStats = async () => {
  try {
    const response = await apiCall(INVITE_LIST_STATS, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching Invite List stats:', error);
    throw error;
  }
};

// Send email for Invite List item
export const sendInviteEmail = async (inviteId, emailData = {}) => {
  try {
    console.log('🚀 sendInviteEmail called with ID:', inviteId, 'and data:', emailData);
    console.log('🔗 Making API call to:', SEND_MAIL);
    
    const response = await apiCall(SEND_MAIL, {
      method: 'POST',
      data: {
        session: inviteId,
        type: 'invite-list',
        ...emailData
      }
    });
    
    console.log('📡 API Response from sendInviteEmail:', response);
    return response;
  } catch (error) {
    console.error('❌ Error sending invite email:', error);
    throw error;
  }
};
